<template>
  <div>
    <Title :pages="[{ icon: 'user-tie', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <v-btn color="primary" class="mb-5" @click="legajoNew">Crear {{ modal_title }}</v-btn>
      <v-btn v-if="create_access" class="mb-5 ml-3" outlined color="primary" @click="dialog_import = true">Importar {{ page_title }}</v-btn>

      <ModalImportExcel
        v-if="create_access"
        :modal_title="'Importar ' + page_title"
        :dialog="dialog_import"
        @updateDialog="(value) => (dialog_import = value)"
        @loadList="loadList(service)"
      />

      <v-card v-if="list_access" class="mb-5 px-4 py-10">
        <div class="row">
          <div class="col-md-6" style="display: flex; align-items: center">
            <v-radio-group v-model="status" row hide-details class="mt-0">
              <v-radio label="Todos" value="all"></v-radio>
              <v-radio label="Activos" value="linked"></v-radio>
              <v-radio label="Desvinculados" value="unlinked"></v-radio>
            </v-radio-group>
          </div>
          <div class="col-md-6" style="display: flex; justify-content: end">
            <v-btn outlined color="primary" class="mr-2" @click="exportToExcel">Exportar</v-btn>

            <v-btn color="primary" @click="loadList(service)">Buscar</v-btn>
          </div>
        </div>
      </v-card>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="list" :search="search" :loading="loading" loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }" @pagination="updatePagination" :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }">
          <template v-slot:item="props">
            <tr style="height: 50px">
              <td>
                <v-avatar size="40">
                  <v-img v-if="props.item.photo_url" :src="props.item.photo_url" alt="Avatar" ></v-img>
                  <v-icon v-else color="grey lighten-1" size="37">mdi-account-circle</v-icon>
                </v-avatar>
              </td>
              <td>{{ props.item.nro_legajo }}</td>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.surname }}</td>
              <td>{{ props.item.document_type.name }} {{ props.item.document }} </td>
              <td>{{ props.item.workstation != null ? props.item.workstation.name : "-" }}</td>
              <td>{{ props.item.sucursal.name }}</td>
              <td>{{ props.item.seniority != null ? props.item.seniority : "-" }}</td>
              <td>
                <v-chip v-if="isUnlinked(props.item)" small color="red lighten-4" text-color="red darken-3">
                  Desvinculado {{ formatDate(props.item.finish_date) }}
                </v-chip>
                <v-chip v-else small color="green lighten-4" text-color="green darken-3">Activo</v-chip>
              </td>

              <td class="text-center px-0 pr-3" style="min-width: 160px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="blue" class="mr-2"
                      @click="editItem(props.item)"> edit </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access && !isUnlinked(props.item)" v-on="on" small color="orange"
                      class="mr-1" @click="unlinkItem(props.item)"> mdi-account-off </v-icon>
                  </template>
                  <span>Desvincular</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access" v-on="on" small color="red" class="mr-2"
                      @click="deleteItem(props.item)"> delete </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <ModalUnlink v-if="update_access" :dialog="dialog_unlink" :legajo="legajo_unlink"
        @updateDialog="(value) => (dialog_unlink = value)" @loadList="loadList(service)" />

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete"
        @deleteItemConfirm="deleteItemConfirm" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { generalService } from "@/libs/ws/generalService";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ModalImportExcel from "./ModalImportExcel.vue";
import ModalUnlink from "./ModalUnlink.vue";

export default {
  components: { Title, DialogDelete, ModalImportExcel, ModalUnlink },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      formatUtils: formatUtils,
      parent: this,
      service: generalService,
      page_title: "Legajos",
      modal_title: "Legajo",
      mainItem: {
        id: "",
        name: "",
      },
      defaultItem: null,
      headers: [
         {
          text: "Foto",
          align: "left",
          sortable: true,
          value: "photo_url",
        },
        {
          text: "N° Legajo",
          align: "left",
          sortable: true,
          value: "nro_legajo",
        },
        {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "name",
        },
        {
          text: "Apellido",
          align: "left",
          sortable: true,
          value: "surname",
        },
        {
          text: "Documento",
          align: "left",
          sortable: true,
          value: "document",
        },
        {
          text: "Puesto",
          align: "left",
          sortable: true,
          value: "workstation",
        },
        {
          text: "Sucursal",
          align: "left",
          sortable: true,
          value: "sucursal",
        },
        {
          text: "Antigüedad",
          align: "left",
          sortable: true,
          value: "hire_date",
        },
        {
          text: "Estado",
          align: "left",
          sortable: true,
          value: "finish_date",
        },
        { text: "Accion", value: "", align: "center" },
      ],
      list: [],
      dialog_delete: false,
      dialog_import: false,
      dialog_unlink: false,
      legajo_unlink: null,
      status: "linked",
    };
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.service.setSection(Constant.SECTION_LEGAJOS);
    this.loadList(this.service);
  },
  methods: {
    getFilterParams() {
      return { status: this.status };
    },
    exportToExcel() {
      if (this.loading) return;
      this.loading = true;
      let param = this.getFilterParams();

      this.service
        .export_filter(param)
        .then((response) => {
          if (Object.prototype.toString.call(response) != "[object ArrayBuffer]" && !response.status) {
            this.$toast.error(response.msg, "Error");
            this.loading = false;
            return;
          }

          let blob = new Blob([response], {
            type: "application/vnd.ms-excel",
          });
          let link = document.createElement("a");
          link.download = "legajos.xlsx";
          link.href = window.URL.createObjectURL(blob);
          link.target = "_blank";
          link.click();
          this.loading = false;
        })
        .catch((e) => {
          console.log("service.export_filter legajos error");
          console.log(e);
          this.loading = false;
        });
    },
    isUnlinked(item) {
      const today = new Date();
      today.setMinutes(today.getMinutes() - today.getTimezoneOffset());
      return item.finish_date != null && item.finish_date <= today.toISOString().substr(0, 10);
    },
    formatDate(date) {
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    unlinkItem(item) {
      this.legajo_unlink = item;
      this.dialog_unlink = true;
    },
    editItem(item) {
      this.$router.push("/legajos/" + item.id);
    },
    legajoNew() {
      this.$router.push("/legajos/new");
    },
    deleteItemConfirm() {
      this.delete(this.service);
      this.dialog_delete = false;
      this.loadList(this.service);
    },
  },
};

// TODO agregar un boton de limpiar busqueda.
</script>
